import { Tooltip } from '@material-ui/core';
import { Info } from 'lucide-react';

export const InfoCircle = ({
  tooltip = '',
  size = 16,
  color
}: {
  tooltip?: string;
  size?: number;
  color?: string;
}) => {
  return (
    <Tooltip title={tooltip} color={color}>
      <Info size={size} />
    </Tooltip>
  );
};
